module.exports = __webpack_public_path__ + "img/icon_home_yanbao.15e358d4.png";